import axios from "axios";
import { syncBaseUrl } from "../database/onlineDb/baseUrl";
import { getAuthTokenFromSessionStorage } from "./common";

let cachedSession = null;
let cachedSessionAuthToken = null;

function isSessionExpired() {
  if (!cachedSession || !cachedSession.expiration) return true;
  const expiry = new Date(cachedSession.expiration).getTime();
  const now = Date.now();
  const fiveMin = 5 * 60 * 1000;
  return now >= expiry - fiveMin;
}

export async function getUploadSession(authToken) {
  const token = authToken || getAuthTokenFromSessionStorage();
  if (
    cachedSession &&
    cachedSessionAuthToken === token &&
    !isSessionExpired()
  ) {
    return cachedSession;
  }
  return refreshSession(token);
}

export async function refreshSession(authToken) {
  const token = authToken || getAuthTokenFromSessionStorage();
  if (!token) {
    throw new Error("No auth token — user not logged in");
  }

  const response = await axios.post(
    `${syncBaseUrl}/s3/upload-session`,
    {},
    {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.data.success) {
    throw new Error(response.data.msg || "Failed to get upload session");
  }

  cachedSession = {
    accessKeyId: response.data.credentials.accessKeyId,
    secretAccessKey: response.data.credentials.secretAccessKey,
    sessionToken: response.data.credentials.sessionToken,
    bucketName: response.data.bucketName,
    region: response.data.region,
    expiration: response.data.credentials.expiration,
  };
  cachedSessionAuthToken = token;

  return cachedSession;
}

export async function getReportUploadSession(s3Key, contentType, authToken) {
  const token = authToken || getAuthTokenFromSessionStorage();
  if (!token) {
    throw new Error("No auth token — user not logged in");
  }

  const response = await axios.post(
    `${syncBaseUrl}/s3/upload-session`,
    { s3Key, contentType },
    {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.data.success) {
    throw new Error(response.data.msg || "Failed to get report upload session");
  }

  return response.data;
}

export function clearSession() {
  cachedSession = null;
  cachedSessionAuthToken = null;
}
